import type { UserProfileJSONObject } from '@ikegps/core-api';
import { ImageButton } from '../../components/button/image.button';
import { MaterialIcon } from '../../components/icon/icons';
import { addStyles } from '../../components/theme';
import { DefaultTheme } from '../../components/theme';
import { UserIcon } from '../../components/user/user.icon';
import { T, Translate } from '../../i18n';
import type { MithrilVNode } from '../../mithril';
import { m } from '../../services/render.service';
import { userDisplayName } from '../../util/userDisplayName';

const CSS = {
	container: 'c-UserCard',
	chip: 'c-UserCard--Chip',
	readonly: 'c-UserCard--ReadOnly',
	content: 'c-UserCard__Content',
	icon: 'c-UserCard__Icon',
	name: 'c-UserCard__Name',
	username: 'c-UserCard__Username',
};

const Style = {
	[CSS.container]: {
		display: 'flex',
		'align-items': 'center',
		cursor: 'pointer',
		'text-align': 'left',
		'line-height': DefaultTheme.space(4),
	},
	[CSS.chip]: {
		'background-color': DefaultTheme.background.lightGrey,
		'border-radius': DefaultTheme.space(6),
	},
	[CSS.readonly]: {
		cursor: 'default',
	},
	[CSS.icon]: {
		'margin-right': DefaultTheme.space(1),
	},
	[CSS.name]: {
		'margin-right': DefaultTheme.space(3),
	},
	[CSS.username]: {
		color: DefaultTheme.font.color.supporting,
	},
};

addStyles(Style);

export interface UserCardCtx {
	me?: boolean;
	action?: (e: MouseEvent) => any;
	cancel?: (e: MouseEvent) => any;
	readonly?: boolean;
}

export const UserCard = {
	view(user: UserProfileJSONObject, content?: MithrilVNode[], ctx: UserCardCtx = {}): MithrilVNode {
		const displayName = userDisplayName(user);

		return m('div', { className: `${CSS.container} ${ctx.readonly ? CSS.readonly : ''}`, onclick: ctx.action }, [
			m('div', { className: CSS.icon }, UserIcon.view(user)),
			m('div', { className: CSS.content }, [
				m('div', { className: CSS.name }, [
					m('span', content != null ? content : displayName),
					ctx.me ? m('span', ` (${Translate(T.ME)})`) : null,
				]),
				displayName !== user.username ? m('div', { className: CSS.username }, user.username) : null,
			]),
		]);
	},
	viewChip(user: UserProfileJSONObject, ctx: UserCardCtx = {}): MithrilVNode {
		return m(
			'div',
			{ className: `${CSS.container} ${CSS.chip} ${ctx.readonly ? CSS.readonly : ''}`, onclick: ctx.action },
			[
				m('div', { className: CSS.icon }, UserIcon.view(user)),
				m('div', { className: CSS.name }, userDisplayName(user)),
				ctx.readonly ? null : ImageButton.view(MaterialIcon.CLOSE, { onclick: ctx.cancel }),
			]
		);
	},
};

export const UserCardUnassigned = {
	view(content: MithrilVNode[], ctx: UserCardCtx = {}): MithrilVNode {
		return m('div', { className: `${CSS.container} ${ctx.readonly ? CSS.readonly : ''}`, onclick: ctx.action }, [
			m('div', { className: CSS.icon }, UserIcon.view(null)),
			m('div', { className: CSS.content }, [m('div', { className: CSS.name }, content)]),
		]);
	},
	viewChip(ctx: UserCardCtx = {}): MithrilVNode {
		return m(
			'div',
			{ className: `${CSS.container} ${CSS.chip} ${ctx.readonly ? CSS.readonly : ''}`, onclick: ctx.action },
			[
				m('div', { className: CSS.icon }, UserIcon.view(null)),
				m('div', { className: CSS.name }, Translate(T.COLLECTION_UNASSIGNED)),
				ctx.readonly ? null : ImageButton.view(MaterialIcon.CLOSE, { onclick: ctx.cancel }),
			]
		);
	},
};
